import React from 'react';
import { useSelector } from 'react-redux';
import { Text } from '@leverege/ui-elements';
import { UI } from '@leverege/ui-redux';
import { formatTimestamp } from '../../../util/Formatting';
import { jsx as _jsx } from "react/jsx-runtime";
export default function GraceEndDate({
  value: companyId
}) {
  const contractsByCompanyId = useSelector(state => UI.get(state, 'contractsByCompanyId') || {});
  const graceEndDate = new Date(contractsByCompanyId[companyId]?.data?.gracePeriodEndDate);
  const isInGracePeriod = graceEndDate.getTime() > Date.now();
  if (!companyId || !isInGracePeriod) {
    return null;
  }
  return /*#__PURE__*/_jsx(Text, {
    children: formatTimestamp(graceEndDate, {
      format: 'P'
    })
  });
}